import type { CustomerCredit } from "@/features/credits/types";

export const CUSTOMER_PAYMENT_REMAINDER_REFERENCE = "xan_apply_customer_payment_remainder";

/** Identifies customer credits created from customer-payment overpayment remainders. */
export function isOverpaymentCredit(credit: CustomerCredit): boolean {
  return credit.reference === CUSTOMER_PAYMENT_REMAINDER_REFERENCE;
}
